<template>
  <v-card>
    <v-card-title class="py-0"
      ><h3>{{ $t('options') }}</h3>

      <v-list-tile-content class="align-end">
        <v-btn @click="$emit('add')" flat color="primary">
          {{ $t('new') }}
        </v-btn>
      </v-list-tile-content></v-card-title
    >
    <v-divider></v-divider>
    <v-data-table :headers="headers" :items="options" class="elevation-1">
      <template v-slot:items="props">
        <td class="text-xs-center" style="max-width:400px">
          <v-btn
            flat
            icon
            color="success"
            class="mr-0"
            @click="$emit('edit', props.item)"
          >
            <v-icon class="icon material-icons">create</v-icon>
          </v-btn>
          <v-btn
            flat
            icon
            color="error"
            class="ml-0"
            @click="$emit('delete', props.item)"
          >
            <v-icon class="icon material-icons">delete</v-icon>
          </v-btn>
        </td>
        <td>{{ getName(props.item.name) }}</td>
        <td class="text-xs-center">{{ props.item.value }}</td>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
export default {
  name: 'OptionList',
  props: {
    items: { type: Array, require: true }
  },
  computed: {
    options() {
      return this.items.slice().sort((a, b) => a.value - b.value)
    },
    headers() {
      return [
        {
          text: this.$t('actions'),
          align: 'center',
          sortable: false,
          width: '150'
        },
        {
          text: this.$t('name'),
          align: 'left',
          sortable: false
        },
        {
          text: this.$t('value'),
          align: 'center',
          value: 'value',
          sortable: false
        }
      ]
    }
  }
}
</script>
